<!-- eslint-disable vuejs-accessibility/anchor-has-content -->
<!-- eslint-disable vuejs-accessibility/click-events-have-key-events -->
<!-- eslint-disable vuejs-accessibility/no-static-element-interactions -->
<template>
  <v-dialog ref="confirm" v-model="dialog" :max-width="options.width" :style="{ zIndex: options.zIndex }" persistent>
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title"> <b> {{ title }} </b> </h4>
        <a @click="dialog = false" class="modal-close">
          <i class="fa fa-times fa-lg" aria-hidden="true"></i>
        </a>
      </div>
      <div class="modal-body" v-if="options.isIqrar">
        <p class="px-8">
          أقر أنا ( <a style="color:#158e8d">{{ currentUserName }}</a>) أني بكامل الأهلية المعتبرة شرعًا مقرّ وموافق على
          النقاط الآتية:
        </p>
        <p class="px-8">
        <ol>
          <li>
            أن المعلومات والبيانات التي سيتم إدخالها صحيحة ودقيقة، وحال ثبوت خلاف ذلك أتحمل المسائلة والآثار النظامية
            للخطأ في المعلومات التي أدخلتها.
          </li>
          <li>
            أني اطلعت على
            <a href="https://www.najiz.sa/applications/landing/terms-conditions">شروط وأحكام</a>
            الخدمات الإلكترونية في موقع بوابة ناجز، وملتزم بها.
          </li>
          <li>
            أني سأُقدم هذا الطلب بنفسي بدون أي ضغط أو إكراه أو تدخل من غيري.
          </li>
          <li>
            أن الخدمة التي سأطلبها لا يوجد أي نزاع أو إجراء قضائي متخذ حيالها، وأن الخدمة التي سأطلبها هي خدمة توثيقية
            منتجة ومرتبة لآثار نظامية معلومة لديّ.
          </li>
          <li>
            أني على معرفة وعلم تام بجميع أطراف العملية التوثيقية، وأنهم على علم بالطلب الذي سأقدمه، والإجراء الذي سينتج
            عنه.
          </li>
          <li>
            أن جميع أطراف العملية التوثيقية لديهم حساب وأرقام هواتف موثقة في نظام أبشر.
          </li>
          <li>
            <p> أني على علم والتزام بالمدد النظامية للطلب الالكتروني، وأن للوزارة الحق في إغلاق الطلب في حال عدم توفير
              المتطلبات أو تجاوز المدة النظامية للطلب. وتأكيدًا على ذلك فإن المدد النظامية لهذا الطلب هي كالآتي:</p>
            <ul>
              <li>
                طلب قيد التصديق من الأطراف: <a style="color:#158e8d">{{ daysToCancelContract }}</a> أيام
              </li>
            </ul>
          </li>
          <li>
            علمي التام في حالة صدور الوثيقة بآلية الاطلاع عليها من خلال الوثائق المعتمدة.
          </li>
          <li>
            الوثيقة الصادرة من النظام الالكتروني لوزارة العدل تعدّ سندًا تنفيذيًّا، وغير قابل للتعديل أو الإلغاء فور
            صدورها.
          </li>
        </ol>
        </p>
      </div>
      <div class="modal-body" v-else>
        <p v-if="message" class="px-8" v-html="message">
        </p>
        <p v-if="description" class="px-8" v-html="description"> </p>
      </div>

      <div class="modal-footer" v-if="options.isIqrar">
        <a class="btn btn-link text-danger mr-auto px-8 text-decoration-none" @click="dialog = false"><b> تراجع </b> </a>
        <a @click="agree" class="btn button--greenFill px-8">موافق</a>
      </div>
      <div class="modal-footer" v-else>
        <a class="btn btn-link text-danger mr-auto px-8 text-decoration-none" @click="cancel"><b> إلغاء </b> </a>
        <a @click="agree" class="btn btn-danger text-white px-8">حذف</a>
      </div>
    </div>
  </v-dialog>
</template>

<script lang="ts">
import {
  Component, Vue, Prop,
} from 'vue-property-decorator';

@Component
export default class ConfirmComponent extends Vue {
  @Prop({ default: '' }) currentUserName!: string;
  @Prop({ default: 0 }) daysToCancelContract!: number;

  dialog = false;
  resolve: any;
  reject: any;
  message = '';
  description = '';
  title = '';
  options = {
    color: '#fff',
    width: 400,
    zIndex: 200,
    noconfirm: false,
    isIqrar: false,
  };

  open(title: string, message: string, description: string, options: any) {
    this.dialog = true;
    this.title = title;
    this.message = message;
    this.description = description;
    this.options = Object.assign(this.options, options);
    return new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

  agree() {
    this.resolve(true);
    this.dialog = false;
  }
  cancel() {
    this.resolve(false);
    this.dialog = false;
  }
}
</script>
<style scoped>
ol {
  list-style: arabic-indic !important;
}

ul {
  list-style: lower-roman !important;
}
</style>
